let Storage = (function () {

    function getIndex(index) {
        return localStorage.getItem(index);
    }

    function setValue(index, value) {
        localStorage.setItem(index, value);
        return getIndex(index);
    }

    function rmValue(index){
        localStorage.removeItem(index);
    }

    return {
        getIndex,
        setValue,
        rmValue
    }

})();

export default Storage;